import {
  DEFAULT_MINIMIZED_HEIGHT,
  DEFAULT_MINIMIZED_WIDTH,
} from "@/helpers/constants";

export const CALL_DIALOG = {
  width: 710,
  height: 200,
  minWidth: 640,
  minHeight: 200,
  minimizedWidth: DEFAULT_MINIMIZED_WIDTH,
  minimizedHeight: DEFAULT_MINIMIZED_HEIGHT,
  top: -1,
  left: -1,
  restoreWidth: 0,
  restoreHeight: 0,
};
